export default __webpack_public_path__ + "static/media/QRcode_Youxuan.01052f3c.jpg";